import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Veteran } from "@/components/Veteran";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-[#0B0E14] min-h-screen" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Services />
      <Veteran />
      <Contact />
      <Footer />
    </div>
  );
}
